module.exports = __webpack_public_path__ + "static/media/mockup-image.77c99a11.jpg";